import enterprises from "./enterprises";
var users = {
  //Users
  async get(uid) {
    const db = window.firebase.firestore();
    let objects = [];
    var ans = await db.collection("/users")
      .where("uid", "==", uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {


          objects.push(
            doc.data()

          );
          console.log(doc.id, " => ", doc.data());
        });
        for (var a = 0; a < objects.length; a++)

          if (window.debug) console.log("will return")
        return objects
      })
      .catch((error) => {
        if (window.debug) console.log("Error getting documents: ", error);
        return error;
      });
    for (var a = 0; a < ans.length; a++)
      ans[a].enterprise = await enterprises.getFromId(ans[a].enterpriseId)
    return ans[0];
  },
  async updatePassword(password) {
    var user = window.firebase.auth().currentUser;
    //var newPassword = getASecureRandomPassword();  

    //var newPassword =  window.firebase.getASecureRandomPassword();

    //alert(JSON.stringify(user));

    await user.updatePassword(password).then(function () {
      // Update successful.
      alert("Senha atualizada");
    }).catch(function (error) {
      // An error happened.
      alert("Senha não atualizada");
    });
  },
  async getAllFromEntepriseId(enterpriseId) {
    const db = window.firebase.firestore();
    let objects = [];
    var ans = await db.collection("/users").where("enterpriseId", "==", enterpriseId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {


          objects.push(
            doc.data()

          );
          console.log(doc.id, " => ", doc.data());
        });
        for (var a = 0; a < objects.length; a++)

          if (window.debug) console.log("will return")
        return objects
      })
      .catch((error) => {
        if (window.debug) console.log("Error getting documents: ", error);
        return error;
      });
    for (var a = 0; a < ans.length; a++)
      ans[a].enterprise = await enterprises.getFromId(ans[a].enterpriseId)
    return ans;
  },
  async getAll() {
    const db = window.firebase.firestore();
    let objects = [];
    var ans = await db.collection("/users")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {


          objects.push(
            doc.data()

          );
          console.log(doc.id, " => ", doc.data());
        });
        for (var a = 0; a < objects.length; a++)

          if (window.debug) console.log("will return")
        return objects
      })
      .catch((error) => {
        if (window.debug) console.log("Error getting documents: ", error);
        return error;
      });
    for (var a = 0; a < ans.length; a++)
      ans[a].enterprise = await enterprises.getFromId(ans[a].enterpriseId)
    return ans;
  },
  async post(user) {

    if (window.debug) console.log("create user:" + JSON.stringify(user))
    var dataSend = {
      "name": (user.name === undefined) ? "" : user.name,
      "email": user.email,
      "enterpriseId": user.enterpriseId,
      "password": user.password,
      "phone": (user.phone === undefined) ? "" : user.phone
    };

    console.log(JSON.stringify(dataSend))

    var url = "https://us-central1-hebelsolar.cloudfunctions.net/app/signup";
    //var url = "http://localhost:5001/hebelsolar/us-central1/app/signup"

    var c = await fetch(url, {
      method: 'POST',
      mode: "cors",
      headers: {
        'Content-Type': 'application/json',
        "user-key": process.env.VUE_APP_API_HEBEL_KEY,
      },
      body: JSON.stringify(dataSend)

    })
      .then((res) => {
        if (window.debug) console.log("first ans")
        console.log(res);

        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log("sec ans")
        console.log(json);
        if (window.debug) console.log("User added")

        return json;
      });
    return c;

  },
  async patch(user) {
    if (user.name === undefined)
      user.name = "";

    if (user.phone === undefined)
      user.phone = "";

    if (window.debug) console.log("update user");

    const db = window.firebase.firestore();
    var usersRef = db.collection("users")
    var e = await usersRef.doc(user.uid).update(user)
    //var e = await usersRef.doc(user.uid).update({ email: user.email, enterpriseId: user.enterpriseId, phone: user.phone, name: user.name })
      .then((docRef) => {
        if (window.debug) console.log("Document successfully updated!" + JSON.stringify(docRef));
        return docRef;
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
    return e;

  },
}

export default users;